/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Graph,
  DetailsPayments,
  DetailsPayouts,
  Button,
  Title,
  Paper,
  Spinner,
  DateRangePicker,
  Table,
  TableFooter
} from '../../components';

import * as actions from '../../actions/index';
import { initializeFinance, onChangeSelection, onSelectDate, calculateFinanceData } from './Finances.services';
import { getInitialDateRange } from '../../utils/suitableDate';
import { styles } from './Finances.styles';
import { FINANCE_TABLE_HEAD } from '../../constants/table';
import _ from 'lodash';
import moment from 'moment';
import { FINANCE_COLORS, UNIT } from '../../constants';
const TableCell = withStyles({
  root: {
    paddingRight: '10px'
  }
})(MuiTableCell);

class Finances extends Component {
  state = {
    isLoading: true,
    isLoadingDate: false,
    accesArray: [],
    dateRange: getInitialDateRange()
  };

  async componentDidMount() {
    const { isAllShops } = this.props;
    await initializeFinance(isAllShops, this);
  }

  async componentWillReceiveProps(props) {
    const { shopId: oldShopId, isAllShops: oldIsAllShops } = this.props;
    const { shopId, isAllShops } = props;
    if (shopId !== oldShopId || (shopId === oldShopId && oldIsAllShops !== isAllShops)) {
      await initializeFinance(isAllShops, this);
    }
  }

  renderStatusFinances = () => {
    return (
      <Button
        color='secondary'
        outlined
        className='btn-xs-block'
        onClick={() => {
          const { showModal } = this.props;
          const modalData = {
            color: 'secondary',
            title: 'Détails des paiements',
            children: <DetailsPayments />,
            header: true,
            btn: 'Default',
            showCancelBtn: false,
            width: '700px',
            fixed: true
          };
          showModal(modalData);
        }}
      >
        Détails des paiements
      </Button>
    );
  };

  renderPaymentTypeButton = (name, type, tab) => {
    const { classes } = this.props;
    return (
      <Grid item md={0}>
        <Button
          variant='contained'
          component='span'
          size='medium'
          className={classes.button}
          onClick={e => onChangeSelection(e, type, tab)}
        >
          {name}
        </Button>
      </Grid>
    );
  };

  createTableRow = (rows) => {
    const { classes } = this.props;

    return (
      <TableBody>
        {_.map(rows, (e) => {
          const { CA, moy, name, shopId, totalOrderTypes = {}, totalCmd = {}, reactivationBasket = 0, retention = 0, rate } = e;
          const renderOrder = (label, value, color) => (
            <p style={{ fontSize: UNIT * 0.875, display: 'flex' }}>
              <div className={classes.black} style={{ width: UNIT * 1.2 }}>{label}:</div>
              <b style={{ color }}>
                {value || 0}
              </b>
            </p>
          );
          const renderOrderType = (value, label) => (
            <div className={classes.orderTypeRow}>
              <span className={classes.value}>{value || 0}</span>
              <span className={classes.label}>{label}</span>
            </div>
          );


          return (
            <TableRow key={shopId} style={{ cursor: 'pointer' }}>
              <TableCell align="center" className={classes.valueC}>
                <b>{name === 'Total' ? 'Total' : name}</b>
              </TableCell>
              <TableCell align="center" className={classes.valueC} style={{ lineHeight: '14px' }}>

                <p className={classes.valueStyle}>{`${CA === 0 ? 0 : CA?.toFixed(2)} €`}</p>
                <p style={{ color: rate > 0 ? FINANCE_COLORS.positiveRate : FINANCE_COLORS.negativeRate }}>
                  {`${rate === 0 ? 0 : rate > 0 ? `+${rate?.toFixed(2)} ` : rate?.toFixed(2)} %`}
                </p>

              </TableCell>

              <TableCell
                align="center"
                className={classes.valueC}
              >
                <div className={classes.tableCellContent}>
                  <div>
                    <b>{totalCmd?.nbCmd || 0}</b>
                  </div>
                  <div>
                    {renderOrder('F', totalCmd?.validateOrder, FINANCE_COLORS.validateOrder)}
                    {renderOrder('A', totalCmd?.canceledCmd, FINANCE_COLORS.canceledCmd)}
                    {renderOrder('M', totalCmd?.missedCmd, FINANCE_COLORS.missedCmd)}
                  </div>
                </div>
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                <div className={classes.tableCellContent}>
                  <div className={classes.orderTypeContainer}>
                    {renderOrderType(totalOrderTypes.delivery, 'en livraison')}
                    {renderOrderType(totalOrderTypes.click_and_collect, 'à emporter')}
                    {renderOrderType(totalOrderTypes.click_and_seat, 'sur place')}
                  </div>
                </div>
              </TableCell>

              <TableCell align="center" className={classes.valueC}>

                <b>{`${moy?.toFixed(2)} €`}</b>

              </TableCell>
              <TableCell align="center" className={classes.valueC}>

                <b>{reactivationBasket}</b>

              </TableCell>
              <TableCell align="center" className={classes.valueC}>

                <b>{retention}</b>

              </TableCell>
            </TableRow>
          );
        })
        }
      </TableBody >
    );
  };

  renderLabel = (label, description, color) => (
    <span style={{ color, fontWeight: 'bolder' }}>
      {label}: {description}
    </span>
  );

  render() {
    const { classes, seedData, showHelpModal, isAllShops, finances, page, shops, customAccountId } = this.props;
    const { isLoading, dateRange, isLoadingDate } = this.state;
    const { shopResults = {} } = isAllShops ? finances['global'] : finances['shop'];
    const { numPage, rowsPerPage } = page;
    const calculatedRows = calculateFinanceData(seedData, shopResults, numPage, rowsPerPage, shops, isAllShops);
    return (
      <div className='px-4 pb-4'>
        <Title title='Finances' onClick={() => showHelpModal('finances')} />
        {isLoading ? (
          <center>
            <Spinner className={classes.progress} />
          </center>
        ) : (
          <div>
            <div className='py-3'>
              <Paper>
                <div className='p-3'>
                  <div className='row mb-3'>
                    <div className='col-12 col-sm-4 align-self-center'>
                      <div className='row'>
                        <div className='col-12'>
                          <DateRangePicker
                            btnClassName='btn-xs-block'
                            className='mr-0 mr-sm-3'
                            dateRange={dateRange}
                            onSelectDate={dateRange => {
                              onSelectDate(this, dateRange);
                            }}
                            disabled={isLoadingDate}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='col-sm-8 d-sm-flex flex-row-reverse mt-3 mt-sm-0 '>
                      <div className='d-flex ml-sm-2'>
                        {!isAllShops && this.renderStatusFinances()}
                      </div>
                      <div className='d-flex mt-3 mt-sm-0 '>
                        {(!isAllShops || customAccountId) && (
                          <Button
                            color='secondary'
                            outlined
                            className='btn-xs-block mr-0'
                            onClick={() => {
                              const { showModal } = this.props;
                              const modalData = {
                                color: 'secondary',
                                title: 'Historique des virements',
                                children: <DetailsPayouts isAllShops={isAllShops} />,
                                header: true,
                                showCancelBtn: false,
                                width: '700px',
                                fixed: true
                              };
                              showModal(modalData);
                            }}
                          >
                            Historique des virements
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                  {isLoadingDate && (
                    <div className='my-5'>
                      <center>
                        <Spinner className={classes.progress} />
                      </center>
                    </div>
                  )}
                  {!isLoadingDate && (
                    <div>
                      <div className={classes.graph}>
                        <Graph isSingleDayRange={moment(dateRange.startDate).isSame(moment(dateRange.endDate), 'day')} />
                      </div>
                      <div className="mt-3">
                        <Table
                          headCells={FINANCE_TABLE_HEAD}
                          classes={classes}
                          bodyRows={calculatedRows}
                          createTableRow={(rows) => this.createTableRow(rows)}
                          order={`${isAllShops && 'asc'}`}
                          orderBy={`${isAllShops && 'name'}`}
                        />


                        <div className="pt-5 ml-3" style={{ fontSize: '12px', color: 'black' }}>
                          <p className={classes.black}>
                            <strong className={classes.valueStyle}>Commandes :</strong>{' '}
                            {this.renderLabel('F', 'finalisées', FINANCE_COLORS.validateOrder)}{' | '}
                            {this.renderLabel('A', 'annulées', FINANCE_COLORS.canceledCmd)}{' | '}
                            {this.renderLabel('M', 'manquées', FINANCE_COLORS.missedCmd)}
                          </p>
                          <p className={classes.black}>
                            <strong>Paniers réactivés :</strong>  Total des commandes passées après réception d’une push notification contenant un code promo de relance de panier abandonné, grâce à notre outil marketing automatique.
                          </p>
                          <p className={classes.black}>
                            <strong>Clients réactivés :</strong> Total des commandes passées après réception d’une push notification contenant un code promo de relance d’un client endormi (qui n’a pas commandé depuis longtemps), grâce à notre outil automatique de rétention.
                          </p>
                        </div>

                        {isAllShops && (
                          <TableFooter lengthOption={_.keys(calculatedRows).length} />

                        )}
                      </div>

                    </div>
                  )}

                </div>
              </Paper>
            </div>
          </div>
        )}
      </div>
    );
  }
}
Finances.propTypes = {
  classes: PropTypes.element.isRequired
};

const mapStateToProps = ({ finances, user, firebaseRealTime, orders, page }) => {
  const { nbShops, shopId, shopName, servicePrice = {}, companyId, isAllShops } = user;
  const { finance, financeGlobalData, shops, generalConfig } = firebaseRealTime;
  const { selectedTableau, selectedGraph, selectedEntity } = finances;
  const { fees = {} } = servicePrice;
  const { servicePrice: generalServicePrice = {} } = generalConfig;
  const { customAccountId } = generalServicePrice;
  return {
    seedData: (finances[selectedEntity] && finances[selectedEntity][selectedTableau]) || [],
    detailsPayments: (finances[selectedEntity] && finances[selectedEntity].details) || [],
    contract: fees.contract,
    paymentFees: fees.stripe,
    brutFinance: finance,
    brutGobalFinance: financeGlobalData,
    nbShops,
    shopId,
    shopName,
    selectedGraph,
    selectedTableau,
    selectedEntity,
    companyId,
    isAllShops,
    finances,
    shops,
    page,
    customAccountId
  };
};

export default compose(withStyles(styles), connect(mapStateToProps, actions))(Finances);
